import type {ImgHTMLAttributes} from 'react';
import {memo} from 'react';

export const Spanner = memo((props: ImgHTMLAttributes<HTMLImageElement>) => {
  return <img src="/assets/spanner_logo.png" alt="" {...props} />;
});
Spanner.displayName = 'Spanner';
